module.exports = __webpack_public_path__ + "static/media/ESHARE.e43f3749.png";